.shell {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: var(--bg);
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem 1.5rem;
  background: var(--panel);
  border-bottom: 1px solid var(--border);
}

.title {
  margin: 0;
  font-size: 1.25rem;
}

.signout {
  background: none;
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 0.4rem 0.85rem;
  color: var(--muted);
}

.signout:hover {
  color: var(--text);
}

.errorBanner {
  background: var(--danger-bg);
  color: var(--danger);
  padding: 0.75rem 1.5rem;
  font-size: 0.9rem;
}

.heroPanel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  background: var(--panel);
  margin: 1rem 1.5rem 0;
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 1.25rem 1.5rem;
  flex-wrap: wrap;
}

.heroStat {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.heroLabel {
  font-size: 0.85rem;
  color: var(--muted);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.heroValue {
  font-size: 2rem;
  font-weight: 700;
  color: var(--text);
}

.heroAsOf {
  font-size: 0.85rem;
  color: var(--muted);
  margin-top: 0.15rem;
}

.downloadAll {
  background: var(--accent);
  color: white;
  border: 0;
  border-radius: 999px;
  padding: 0.6rem 1.25rem;
  font-size: 0.9rem;
  font-weight: 600;
}

.downloadAll:hover:not(:disabled) {
  background: var(--accent-hover);
}

.downloadAll:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.rangeBar {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin: 1rem 1.5rem 0;
  padding: 0.75rem 1.25rem;
  background: var(--panel);
  border: 1px solid var(--border);
  border-radius: 12px;
}

.rangeBarLabel {
  font-size: 0.85rem;
  color: var(--muted);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-weight: 600;
}

.panel {
  background: var(--panel);
  margin: 1rem 1.5rem 0;
  border: 1px solid var(--border);
  border-radius: 12px;
  overflow: hidden;
}

.panel:last-of-type {
  margin-bottom: 1rem;
}

.panelHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem 0.5rem;
  gap: 1rem;
}

.panelDownload {
  background: var(--panel);
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 0.35rem 0.85rem;
  font-size: 0.85rem;
  font-weight: 600;
}

.panelDownload:hover:not(:disabled) {
  background: var(--bg);
}

.panelDownload:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.panelTitle {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 600;
}

.controls {
  padding: 0 1.25rem 0.75rem;
}

.chartArea {
  padding: 0.5rem 1rem 1rem;
  min-height: 360px;
}

.export {
  background: var(--panel);
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 0.4rem 1rem;
  font-size: 0.9rem;
  font-weight: 600;
}

.export:hover:not(:disabled) {
  background: var(--bg);
}

.export:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
